import React, {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSendData, setTechnician } from "../../../Store/Slice/scheduleSlice";
import useGetVerificationTextApi from "../../../Global/Api/Schedule/getVerificationTextApi";
import useGetAffirmDueDaysApi from "../../../Global/Api/Schedule/getAffirmDueDaysApi";
import {useParams} from "react-router-dom";

export default function InfoText() {
    const {title: jobTitle} = useParams()
  const dispatch = useDispatch();
  const getVerifText = useGetVerificationTextApi();
  const getAffirmDays = useGetAffirmDueDaysApi();

  const lineItems = useSelector((state) => state.rootReducer.scheduleSlice.line_items);
  const sendData = useSelector((state) => state.rootReducer.scheduleSlice.sendData);

  useEffect(() => {
    getVerifText.get()
    getAffirmDays.get()
  }, [])

  useEffect(() => {
    const itemStrings = lineItems?.map((item) => {
      const quantity = item?.quantity ?? 'N/A';
      const label = item?.data?.label ?? 'N/A';
      return `${quantity} ${label}`;
    });

    dispatch(setTechnician({ description_more: itemStrings?.join() }));
    dispatch(setSendData({ description_more: itemStrings?.join() }));
  }, [lineItems])

  return (
    <div className="tech__block-text">
      <div className="tech__block-list">
        {!jobTitle && lineItems?.map((item) => (
          <div key={item?.id} className="tech__block-item">
            {item?.quantity} {item?.data?.label}
          </div>
        ))}
      </div>
      {!jobTitle && sendData?.verification_text && (
        <div className="tech__block-some">
          {sendData?.verification_text}
        </div>
      )}
      <textarea
        placeholder="Enter description"
        className="tech__block-textarea"
        value={sendData?.description || ''}
        onChange={(e) => {
          dispatch(setTechnician({ description: e.target.value }));
          dispatch(setSendData({ description: e.target.value }));
        }}
      />
    </div>
  );
}
